import React, { useEffect, useRef } from 'react';
import {
  PENDING_FINAL_SUBMISSION_COPY,
  handleCheckPendingFinalProgress
} from '../offline/pendingFinalSubmissionUi';

/**
 * Explains that a final count is queued locally and offers an explicit refresh.
 */
export default function PendingFinalSubmissionModal({
  open,
  onStayOnPage,
  onCheckProgress = handleCheckPendingFinalProgress,
  copy = PENDING_FINAL_SUBMISSION_COPY
}) {
  const primaryRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const t = window.setTimeout(() => {
      try {
        primaryRef.current?.focus();
      } catch (_) {
        /* ignore */
      }
    }, 0);
    const onKeyDown = (e) => {
      if (e.key === 'Escape' && typeof onStayOnPage === 'function') {
        onStayOnPage();
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => {
      window.clearTimeout(t);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open, onStayOnPage]);

  if (!open) return null;

  return (
    <div
      className="cs-modal-overlay"
      onClick={() => {
        if (typeof onStayOnPage === 'function') onStayOnPage();
      }}
      role="presentation"
    >
      <div
        className="cs-modal cs-pending-final-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cs-pending-final-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="cs-pending-final-modal-title" className="cs-modal-title cs-modal-title-neutral">
          {copy.title}
        </h2>
        {(copy.paragraphs || []).map((text) => (
          <p key={text} className="cs-modal-text">
            {text}
          </p>
        ))}
        {copy.secondaryNote ? (
          <p className="cs-modal-confirm cs-pending-final-modal-note">{copy.secondaryNote}</p>
        ) : null}
        <div className="cs-modal-actions cs-pending-final-modal-actions">
          <button type="button" className="cs-btn-cancel" onClick={onStayOnPage}>
            {copy.stayOnPageLabel}
          </button>
          <button
            ref={primaryRef}
            type="button"
            className="btn btn-primary"
            onClick={onCheckProgress}
          >
            {copy.checkProgressLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
